/** Custom event name — header bell listens and refetches unread count / list. */
export const INFRA_NOTIFICATIONS_REFRESH_EVENT = 'infrastructure-notifications-refresh';

/** Call after infrastructure leasing API mutations so the header bell updates. */
export function dispatchInfrastructureNotificationsRefresh() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(INFRA_NOTIFICATIONS_REFRESH_EVENT));
  }
}
